<template>
    <tbody class="table-wrapper">
        <tr>
            <td>
                {{ this.data }}
            </td>
        </tr>
    </tbody>
</template>

<script>

export default {
    name: "TableTd",
    props: ["data"],
}
</script>

<style lang="less" scoped>
.table-wrapper {
    white-space: pre-line;
}
</style>